import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import {ArticlePageLayout} from '../../../components/DataDisplay';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getPreferenceCenterType} from '../../../consts/tnc/tncTypes';
import analyticsService from '../../../services/analyticsService';
import {getInitialLanguageCode} from '../../../services/localization/localizationService';
import marketConfigService from '../../../services/marketConfigService';
import tncService from '../../../services/tncService';
import {selectIotDeviceType} from '../../../state/selectors/iotDevice';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import TermsOfUseDescription from '../TermsOfUseDescription/TermsOfUseDescription';
import DCExpansionPanel from './components/DCExpansionPanel';
import PreferenceCenterDescription from './components/PreferenceCenterDescription';
import SaveContinueButton from './components/SaveContinueButton';

const PreferenceCenter = (props) => {
    const {description, acceptedLegals, legals, onApproved, ariaLabel} = props;
    const deviceType = useSelector(selectIotDeviceType);
    const tncType = getPreferenceCenterType();
    const isUnitedTNCEnabled = marketConfigService.isUnitedTNCEnabled();
    const language = getInitialLanguageCode();
    const {legalsSettingsNotNull, filteredAcceptedLegals} = tncService.getPreferenceCenterLegals(
        legals,
        acceptedLegals
    );

    const [acceptedSettingList, setAcceptedSettingList] = useState(filteredAcceptedLegals);

    useEffect(() => {
        setAcceptedSettingList(filteredAcceptedLegals);
    }, [acceptedLegals]);

    useEffect(() => {
        analyticsService.pushPreferenceCenterEvent();
    }, []);

    const onSettingLegalChange = (code, isAccepted) => {
        if (isAccepted) {
            setAcceptedSettingList([...acceptedSettingList, code]);
        } else {
            const isCodeInList = acceptedSettingList.indexOf(code) !== -1;

            if (isCodeInList) {
                const filteredList = acceptedSettingList.filter((el) => el !== code);

                setAcceptedSettingList(filteredList);
            }
        }
    };

    return (
        <ArticlePageLayout
            className='w-full'
            containerClassName='pt-3 md:pt-6 lg:pt-6 hyphens-auto'
            titleKey={localizationKeys.PREFERENCE_CENTER_TITLE_TEXT}
            titleClassName='mb-3 sm:mb-4'
            lang={language}
        >
            {isUnitedTNCEnabled && (
                <TermsOfUseDescription className={'mb-4'} innerHtml={description} tncType={tncType} />
            )}
            {!isUnitedTNCEnabled && <PreferenceCenterDescription />}
            {legalsSettingsNotNull.map(({code, title, text}, index) => {
                return (
                    <div className='w-full' key={code}>
                        <DCExpansionPanel
                            index={code}
                            title={title}
                            innerText={text}
                            onChange={(value) => onSettingLegalChange(code, value)}
                            isActive={acceptedSettingList.includes(code)}
                            testId={`${elementsTesIds.PREF_CENTER_TOGGLE}${index}`}
                        />
                    </div>
                );
            })}
            <SaveContinueButton
                deviceType={deviceType}
                legals={legals}
                ariaLabel={ariaLabel}
                onApproved={onApproved}
                legalsSettingsNotNull={legalsSettingsNotNull}
                acceptedSettingList={acceptedSettingList}
            />
        </ArticlePageLayout>
    );
};

export default PreferenceCenter;
